import { useIntl } from 'react-intl';
import StatusBadge from 'src/componentes/StatusBadge';
import DocumentoArquivosList from '../../Components/DocumentoArquivosList';
import './DocumentoSituacaoAtualCard.css';

const formatarData = (data, intl) => {
  if (!data) return '-';

  const parsedDate = new Date(data);
  if (Number.isNaN(parsedDate.getTime())) return '-';

  return intl.formatDate(parsedDate, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

const obterStatusNome = (status) => {
  if (!status) return null;
  if (typeof status === 'string') return status;

  return status?.nome || status?.descricao || status?.label || null;
};

const obterStatusAtual = (model, ultimoVersionamentoManual) => {
  return (
    model?.statusAtual ||
    ultimoVersionamentoManual?.statusAtual ||
    model?.status ||
    null
  );
};

const obterStatusProximaVersao = (model) => {
  const statusProximaVersaoNome = model?.statusProximaVersao?.nome;
  if (typeof statusProximaVersaoNome !== 'string') return null;

  const statusFormatado = statusProximaVersaoNome.trim();
  return statusFormatado || null;
};

function DocumentoSituacaoAtualCard({ model, documentName, documentType }) {
  const intl = useIntl();
  const ultimoVersionamentoManual = model?.ultimoVersionamentoManual;
  const statusAtual = obterStatusAtual(model, ultimoVersionamentoManual);
  const nomeStatusAtual = obterStatusNome(statusAtual) || '-';
  const corStatusAtual = statusAtual?.cor || model?.status?.cor;
  const corFundoStatusAtual =
    statusAtual?.corFundo ||
    model?.status?.corFundo ||
    corStatusAtual ||
    '#d4e8f2';
  const possuiCorFundoStatusAtual = Boolean(
    statusAtual?.corFundo || model?.status?.corFundo
  );
  const arquivos = Array.isArray(model?.arquivos) ? model.arquivos : [];
  const bloqueiaDownload = !!model?.bloquearDownload;
  const statusProximaVersao = obterStatusProximaVersao(model);
  const exibirStatusProximaVersao = Boolean(statusProximaVersao);
  const periodoVersao = `${formatarData(
    ultimoVersionamentoManual?.dataInicio,
    intl
  )} - ${formatarData(ultimoVersionamentoManual?.dataTermino, intl)}`;

  return (
    <div className="documento-situacao-atual-card">
      <div className="documento-situacao-atual-card__title pb-3">
        {intl.formatMessage({
          id: 'labelDocumentoSituacaoAtual',
        })}
      </div>

      <div className="documento-situacao-atual-card__meta-row">
        <StatusBadge
          className="documento-situacao-atual-card__status-badge"
          text={nomeStatusAtual}
          textColor={possuiCorFundoStatusAtual ? corStatusAtual : undefined}
          backgroundColor={corFundoStatusAtual}
          style={{
            borderRadius: 16,
            padding: '4px 12px',
            fontWeight: 500,
          }}
        />
        <span className="documento-situacao-atual-card__meta-item">
          <strong className="documento-situacao-atual-card__meta-label">
            {intl.formatMessage({ id: 'codigo' })}:
          </strong>{' '}
          <span className="documento-situacao-atual-card__meta-value">
            {ultimoVersionamentoManual?.codigo || '-'}
          </span>
        </span>
        <span className="documento-situacao-atual-card__meta-item">
          <strong className="documento-situacao-atual-card__meta-label">
            {intl.formatMessage({
              id: 'labelPeriodoVersao',
            })}
            :
          </strong>{' '}
          <span className="documento-situacao-atual-card__meta-value">
            {periodoVersao}
          </span>
        </span>
        {exibirStatusProximaVersao && (
          <span className="documento-situacao-atual-card__meta-item">
            <strong className="documento-situacao-atual-card__meta-label">
              {intl.formatMessage({
                id: 'labelProximaVersao',
              })}
              :
            </strong>{' '}
            <span className="documento-situacao-atual-card__meta-value">
              {statusProximaVersao}
            </span>
          </span>
        )}
      </div>

      <DocumentoArquivosList
        arquivos={arquivos}
        disabledDownload={bloqueiaDownload}
        documentName={documentName}
        documentType={documentType}
        tipoCopiaDocumento={model?.tipoCopiaDocumentoId}
        quantidadePermitidaCopias={model?.quantidadePermitidaCopias}
        statusAtual={statusAtual}
        parameters={{
          documentoId: model?.id,
        }}
      />
    </div>
  );
}

export default DocumentoSituacaoAtualCard;
